import {Injectable} from "@angular/core";

import {IIdentityService} from "libComm";
import {MsalService} from "@azure/msal-angular";
import {last, Observable} from "rxjs";
import {map} from "rxjs/operators";

@Injectable({
	providedIn: 'root'
})
export class OEMIdentityService implements IIdentityService
{
	constructor(private oemmsal: MsalService)
	{
	}

	// provide user identification token
	getUserIdentityTokenObs(): Observable<string>
	{
		/*
		lastValueFrom(
			this.msalService.acquireTokenSilent({
				scopes: ['openid', 'profile', 'User.Read', 'email']
			})
		).then((token) =>
		{
			this.clipboard.copy(token.idToken);
		});
		*/
		const resObs= this.oemmsal.acquireTokenSilent({
			scopes: ['openid', 'profile', 'User.Read', 'email']
		}).pipe(
			map(token => token.idToken),
			last() // only the last value is returned
		);

		return resObs;
	}
}
